import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { defaultProfilePostsFilterSchema } from '@anytag/shared-organisms';

export const AnalyticsIgBrandAmbassadorPostsSearchSchema = SearchSchema.create({
  filter: defaultProfilePostsFilterSchema
});

export type AnalyticsIgBrandAmbassadorPostsSearchSchemaType = z.infer<
  typeof AnalyticsIgBrandAmbassadorPostsSearchSchema
>;
